import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

export function Paginacion(props) {
  //console.log("props = " + JSON.stringify(props));
  const { total, page, size, search1, search2, url, handle } = props;
  const first = 1;
  const last = Math.ceil(total / size);
  const pages = [...Array(last).keys()].map(p => p + 1);
  const groupsize = 10;
  const group = Math.trunc((page - 1) / groupsize);
  //console.log("total = " + total + " size = " + size + " last = " + last);
  //console.log("pages.length = " + pages.length);
  return (pages.length > 1 && 
    <Pagination size="lg" className="nav justify-content-center">
      <PaginationItem key={ "f" }>
      <PaginationLink onClick={() => handle(url, first, size, search1, search2)}>{ String.fromCharCode(171) }</PaginationLink>
      </PaginationItem>
      <PaginationItem key={ "a" }>
        <PaginationLink onClick={() => handle(url, Math.max(page - 1, first), size, search1, search2)}>{ String.fromCharCode(60) }</PaginationLink>
      </PaginationItem>
      { pages.length < groupsize ? pages.map((p, i) =>
        <PaginationItem key={ i } active={ page == p }>
          <PaginationLink onClick={() => handle(url, p, size, search1, search2)}>
            {p}
          </PaginationLink>
        </PaginationItem>
    ) : pages.filter((p, i) => p > (group * groupsize) && p <= ((group+1)*groupsize)).map((p, i) =>
      <PaginationItem key={i} active={page == p}>
        <PaginationLink onClick={() => handle(url, p, size, search1, search2)}>
          {p}
        </PaginationLink>
      </PaginationItem>
    )}
      <PaginationItem key={"s"}>
        <PaginationLink onClick={() => handle(url, Math.min(page + 1, last), size, search1, search2)}>{ String.fromCharCode(62) }</PaginationLink>
      </PaginationItem>
      <PaginationItem key={"u"}>
        <PaginationLink onClick={() => handle(url, last, size, search1, search2)}>{ String.fromCharCode(187) }</PaginationLink>
      </PaginationItem>
    </Pagination>  
  );
}